import { render, staticRenderFns } from "./fagj.vue?vue&type=template&id=db3e8cb8&scoped=true&"
import script from "./fagj.vue?vue&type=script&lang=js&"
export * from "./fagj.vue?vue&type=script&lang=js&"
import style0 from "./fagj.vue?vue&type=style&index=0&id=db3e8cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3e8cb8",
  null
  
)

export default component.exports